import React from 'react';
import RecentGameList from './sub/RecentGameList';
import { useTranslation } from 'react-i18next';

function RecentGameMain(props) {
    let playerObj = props['profile'];
    let {leagueType} = props;
    const { t } = useTranslation();

    return (
        <>
            <div className="boxTitle">
                {t('Last7G')}
            </div>
            <div className="recordTable">
                <RecentGameList profile={playerObj} leagueType={leagueType}/>
            </div>
        </>
    )
}

export default RecentGameMain;